import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMapPin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMapPin2"><Path d="M19.75 10.1C19.75 5.90264 16.2802 2.5 12 2.5C7.71979 2.5 4.25 5.90264 4.25 10.1C4.25 14.6469 9.62953 17.8503 11.462 21.5H12.5384C14.3709 17.8503 19.75 14.6469 19.75 10.1Z" stroke="currentColor"/><Path d="M8.5 10.25C8.5 8.317 10.067 6.75 12 6.75C13.933 6.75 15.5 8.317 15.5 10.25C15.5 12.183 13.933 13.75 12 13.75C10.067 13.75 8.5 12.183 8.5 10.25Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconMapPin2;
